var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_1224_1433)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1224_1433",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1224_1433",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1224_1433",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAdlJREFUWEftlzFrFFEUhc+5yzbBgIVJq4VoYQohAYs0K3YhbQoLUXf33V2wsQ0WJqC9lTjvDXHTiCL4C4SkESxTKNhpKQQxpWzxrjzZkc1uYiQ7S5qZcuC9+3HunXPuEGf88IzrowIYU6DdbjdIrgFYIzlXUou+AchjjB/yPN8dvnMMQFUfAXgC4LOZ7ZcBICKzZrZoZs9DCA9OAvhK8keWZUtlFC/uUNVPZjYfQpg/CcDMbDeEcLNMAOfcDsmG9/6Q6ke1oAIoRYFmszlbr9dXzezqoJV3AVwCsJkG3Hv/Nr2fSgu63e5CjPE1gGvHzVExZ1MBUNUOgBdmdt/Mkgf8eURkLsa4LyINAI9F5MZUAI6b+AIkmZ2I7KR2VACVApUClQJMni0ii0NulQxiL8a4fdo4FpG0dFwejd4jjcg5d4/ky9MW+9e5AkBVHwK4Q/JplmXvDjlhp9NJfr01SCmk1QnAuUmASF4HcL4AcM69Ink71fDeb4wC3DKz9wB+xhhX8jz/OEnxdHY0C1qt1sVardbo9/tver3er7EsUNWNlE6Dwl/M7PskECQvAFgwswOSB8OJWNxL8oqILP/9DFU1reLrANICMTMJwH+c3QOw7b1/Vv0ZVQr8BpaGZAA+cvzxAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.eda1db5a60a3c5691fec73e9ff53ade7.svg";
export { ForwardRef as ReactComponent };